import React, { Component } from 'react';
import Loading from './Loading';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import '../css/Loan.css';

class WelfareList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingShow: true,
            account: [],
            is_account: true
        }
        _isLogin().then(value => {
            if (value) this.getLoanAccount();
        });
    }

    getLoanAccount() {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.welfare.list.php', param)
            .then(res => {
                console.log('res', res)
                this.setState({ loadingShow: false, is_account: (res.data.status) ? true : false })
                if (res.data.status) {
                    this.setState({ account: res.data.data.loan });
                } else {
                    if (res.data.responseText === 101) {
                        localStorage.clear();
                        _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                    }
                }
            }).catch(err => {
                this.setState({ loadingShow: false });
                _Alert('error');
            });
    }

    // gotoTransaction(id) {
    //     window.location.href = variable().BASE_URL + "/online/loan/" + id;
    // }

    renderLoanAccount() {
        return (
            <div>
                <table className="table table-loan">
                    <thead>
                        {
                            (this.state.account.length > 0) ?
                                <tr>
                                    <th scope="col">ลำดับ</th>
                                    <th scope="col">สวัสดิการ</th>
                                    <th scope="col">จำนวนเงิน</th>
                                    <th scope="col">วันที่รับเงิน</th>
                                </tr>
                                :
                                null
                        }
                    </thead>
                    <tbody>
                        {
                            this.state.account.map(account => (
                                <tr key={account.id} >
                                    <td>{account.index}</td>
                                    <td>{account.benefit_name}</td>
                                    <td>{account.available} บาท</td>
                                    <td>{account.date}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>


                <div className="mobile-loan-content">
                    {
                        this.state.account.map((account, index) => (
                            <div key={account.id} onClick={(e) => this.gotoTransaction(account.id)} className={(index === 0) ? 'is-first loan-loop' : 'loan-loop'}>
                                <div className="loan-row">
                                    <div className="loan-row-first"><span className="text-title">ลำดับ :  </span><span className="text-desc">{account.index}</span></div>
                                    <div className="loan-row-second"><span className="text-title">สวัสดิการ : </span><span className="text-desc">{account.benefit_name}</span></div>
                                </div>
                                <div className="loan-row">
                                    <div className="loan-row-third"><span className="text-title">จำนวนเงิน : </span><span className="text-desc type-desc">{account.available} บาท</span></div>
                                    <div className="loan-row-fourt"><span className="text-title">วันที่รับเงิน : </span><span className="text-desc">{account.date}</span></div>
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="card">
                <Loading show={this.state.loadingShow} />
                <div className="card-title">
                    <div className="card-icon"><i className="fas fa-dollar-sign"></i></div>
                    <div className="card-title-text">สวัสดิการ</div>
                </div>
                <div className="card-content card-loan">
                    {
                        (this.state.is_account) ?
                            this.renderLoanAccount()
                            :
                            <div className="no-data">ไม่พบบัญชีสวัสดิการ</div>
                    }
                </div>
            </div>
        )
    }
}

export default WelfareList;